import { createContext, useContext, useState } from 'react'

const SidebarNavContext = createContext(null)

export function SidebarNavProvider({ children }) {
  const [sidebarNav, setSidebarNav] = useState(null)
  const [backPath, setBackPath] = useState(null)
  return (
    <SidebarNavContext.Provider value={{ sidebarNav, setSidebarNav, backPath, setBackPath }}>
      {children}
    </SidebarNavContext.Provider>
  )
}

export function useSidebarNav() {
  const ctx = useContext(SidebarNavContext)
  if (!ctx) throw new Error('useSidebarNav must be used inside SidebarNavProvider')
  return ctx
}
